{
  "version": 1,
  "asset_id": "49a9548b-7a47-489a-90ef-d775ec4374b1",
  "project_id": "3d822431-c8cc-4039-949e-267692693cd8",
  "url": "/__l5e/assets-v1/49a9548b-7a47-489a-90ef-d775ec4374b1/erin-wilkinson.webp",
  "r2_key": "a/v1/3d822431-c8cc-4039-949e-267692693cd8/49a9548b-7a47-489a-90ef-d775ec4374b1/erin-wilkinson.webp",
  "original_filename": "erin-wilkinson.webp",
  "size": 39990,
  "content_type": "image/webp",
  "created_at": "2026-08-11T22:26:56Z"
}
